export class ListNode {
    public next?: ListNode;

    constructor(
        public readonly node: any
    ) {}
}
